export default function app_busca_sessao(state = {}, action) {
  switch(action.type) {
    case 'add_app_busca_sessao': 
      state = action.json;
      return state;
    default: 
      return state; 
  }
}